export default "__VITE_ASSET__Bp6raLJL__"